(function() {
    'use strict';

    angular.module('Logger', [])

    // Angular Constants
    // toastr is actually set in toastr.js as window.toastr
    // making it globally available here.
    .constant('toastr', toastr)

    .config(toastrConfig);

    toastrConfig.$inject = ['toastr'];

    function toastrConfig(toastr) {
        toastr.options.timeOut = 12000;
        toastr.options.positionClass = 'toast-top-right';
    }

})();

(function() {
    'use strict';

    angular
        .module('Logger')
        .factory('logger', logger);

    logger.$inject = ['$log', 'toastr'];

    function logger($log, toastr) {
        var service = {

            // turn off the toasts programmatically.
            showToasts: true,

            error   : error,
            info    : info,
            success : success,
            warn    : warn,
            clear   : clear,
            remove  : remove

        };

        return service;
        /////////////////////

        function error(message, data, title, overrideOptions) {
            if(service.showToasts){
                toastr.error(message, title, overrideOptions);
            }
            $log.error('Error: ' + message, data);
        }

        function info(message, data, title, overrideOptions) {
            if(service.showToasts){
                toastr.info(message, title, overrideOptions);
            }
            $log.info('Info: ' + message, data);
        }

        function success(message, data, title, overrideOptions) {
            if(service.showToasts){
                toastr.success(message, title, overrideOptions);
            }
            $log.info('Success: ' + message, data);
        }

        function warn(message, data, title, overrideOptions) {
            if(service.showToasts){
                toastr.warning(message, title, overrideOptions);
            }
            $log.warn('Warning: ' + message, data);
        }

        function clear(){
            toastr.clear();
        }

        function remove(){
            toastr.remove();
        }

    }
}());


(function(){

    'use strict';

    angular
        .module('Utilities', [])
        .factory('utility', utilities)
        .factory('HttpService',HttpService);

        utilities.$inject = ['$log','$filter','HttpService'];

        function utilities($log,$filter,HttpService) {

            $log.log('Js Utilities has loaded.');

            var factory = {
                routeParams     : routeParams,
                odbcToNGDate    : odbcToNGDate,
                odbcToDate    : odbcToDate,
                dateToSQLDate   : dateToSQLDate,
                HttpService     : HttpService
            }

            return factory;

            // returns url route friendly string: /:wbs1/:wbs2?/:wbs3? 
            function routeParams(wbs1,wbs2,wbs3){
                var wbs1 = wbs1 || ''; // equivalent to sql coalesce
                var wbs2 = wbs2 || '';
                var wbs3 = wbs3 || '';
                wbs1 = wbs1.toString();
                wbs2 = wbs2.toString();
                wbs3 = wbs3.toString();
                var route = "";
                if( wbs1.length > 0 && wbs1.length < 15 ){
                    route = wbs1;
                    if( wbs2.length > 0 && wbs2.length < 6 ){
                        route += "/" + wbs2;
                        if( wbs3.length > 0 && wbs3.length < 6){
                            route += "/" + wbs3;
                        }
                    }
                    return route;
                }
                return "INVALIDWBS1";
            };

            // convert sql odbc datetime to angular date
            function odbcToDate(odbcdate){
                return new Date(odbcdate);
            }


            // convert sql odbc datetime to angular date
            function odbcToNGDate(odbcdate,format){
                var format = format || 'longDate'; // 'shortDate'
                var date = new Date(odbcdate);
                return $filter('date')(date,format);
            }

            // convert js datetime to mssql date
            function dateToSQLDate(date){
                return date.getFullYear().toString()  + '-' + (date.getMonth() + 1).toString() + '-' + date.getDate().toString();
            }

        };

        HttpService.$inject = ['$http','$q','$log','logger'];

        function HttpService($http,$q,$log,logger){
            var factory = {
                sendRequest: sendRequest,
                post: post,
                sendLocalRequest: sendLocalRequest
            };
            return factory;

            //Send HTTP Request
            function sendLocalRequest(path,params,method,domain){
                if(method == undefined)
                    method="GET";
                else
                    method="POST";
                
                //Determine Domain Path
                var domainpath = _globalAPIEnv;
                if(domain !== undefined){
                    domainpath = domain;
                }

                var request = $http({
                     method: method,
                     url: path,
                     data: params
                 });
                return(request.then(handleSuccess,handleError));
            };
            
            //Send HTTP Request
            function sendRequest(url,params,method,domain){
                if(method == undefined)
                    method="GET";
                else
                    method="POST";
                
                //Determine Domain Path
                var domainpath = _globalAPIEnv;
                if(domain !== undefined){
                    domainpath = domain;
                }

                var request = $http({
                     method: method,
                     url: domainpath + url,
                     data: params
                 });
                return(request.then(handleSuccess,handleError));
            };

            //Send HTTP Request
            function post(url,params,method,domain){
                if(method == undefined)
                    method="GET";
                else
                    method="POST";
                
                //Determine Domain Path
                var domainpath = _globalAPIEnv;
                if(domain !== undefined){
                    domainpath = domain;
                }

                var request = $http({
                     method: method,
                     url: domainpath + url,
                     params: params
                 });
                return(request.then(handleSuccess,handleError));
            };

            //Error Handler
            function handleError(response) {
                if (!angular.isObject( response.data ) || ! response.data.message){
                    logger.error("An unknown error occurred.");
                    return($q.reject("An unknown error occurred."));
                }
                logger.error(response.data.message, {}, 'Request Error', {timeOut: 10000,positionClass:'toast-bottom-right'});
                return($q.reject(response.data.message));
            }

            //Success Handler
            function handleSuccess(response){
                return response.data;
            }
        }

})();

(function(){

    'use strict';

	angular
		.module('psomas.barSimple',[])
		.directive('psomasBarSimple',psomasBarSimple);


	function psomasBarSimple(){
		return {
			controller: psomasBarSimpleDirectiveController,
			templateUrl: '/assets/js/PsomasBarSimple/psomas-bar-simple.html?rev=N990'
		};
	};

	function psomasBarSimpleDirectiveController(){


	}


})();

(function(){

    'use strict';

    angular
        .module('psomas.theme', [

            // Angular Modules
            'ngMaterial'

        ])
        .config(['$mdThemingProvider',function($mdThemingProvider) {

            $mdThemingProvider
                .definePalette('psomasPrimaryBlue', {
                    '50': 'E2E9F2',
                    '100': 'BBC9DF',
                    '200': '92A9CC',
                    '300': '6586B6',
                    '400': '446CA7',
                    '500': '0C3350',/*0C3350*/
                    '600': '204B8A',
                    '700': '1D437B',
                    '800': '193B6C',
                    '900': '122B4F',
                    'A100': 'F9F9F9',
                    'A200': '92A9CC',
                    'A400': '446CA7',
                    'A700': '1D437B',
                    'contrastDefaultColor': 'light',    // whether, by default, text (contrast) on this palette should be dark or light
                    'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                    '200', '300', '400', 'A100'],
                    'contrastLightColors': undefined    // could also specify this if default was 'dark'
                })

                .definePalette('psomasSecondaryOrange', {
                    '50': 'FDF0E2',
                    '100': 'F9DBBA',
                    '200': 'F6C691',
                    '300': 'F1AE64',
                    '400': 'EE9D43',
                    '500': 'EC8C23',/*0C3350*/
                    '600': 'D67F1F',
                    '700': 'BF711C',
                    '800': 'A76318',
                    '900': '7B4912',
                    'A100': 'F9DBBA',
                    'A200': 'F6C691',
                    'A400': 'EE9D43',
                    'A700': 'BF711C',
                    'contrastDefaultColor': 'light',    // whether, by default, text (contrast) on this palette should be dark or light
                    'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                    '200', '300', '400', 'A100'],
                    'contrastLightColors': undefined    // could also specify this if default was 'dark'
                })
                .definePalette('psomasTertiaryWhite', {
                    '50': 'fff',
                    '100': 'fff', // tab inactive font color
                    '200': 'fff',
                    '300': 'fff',
                    '400': 'fff',
                    '500': 'F0F0F0', // tabs background color
                    '600': 'fff',
                    '700': 'fff',
                    '800': 'fff',
                    '900': 'fff',
                    'A100': 'fff',
                    'A200': 'fff',
                    'A400': 'fff',
                    'A700': 'fff'
                })

                // TODO: create separate palette for accent, this violates angular rules
                .theme('default')
                .primaryPalette('psomasPrimaryBlue')
                .accentPalette('orange')
                .warnPalette('red');

                $mdThemingProvider.theme('psomasprimary','default').primaryPalette('psomasPrimaryBlue');
        }]);

})();

(function () {

    'use strict';

    angular
        .module('app.login', [])
        .controller('loginCtrl', loginCtrl);

    loginCtrl.$inject = ['$scope', 'common', 'loginservice', '$mdToast', '$window'];

    function loginCtrl($scope, common, loginservice, $mdToast, $window) {

        //Methods
        $scope.processLogin = processLogin;
       
        $scope.showToast = showToast;

        //Variables
        $scope.login = { idnumber: undefined, password: undefined };
        $scope.progress = false;
        $scope.user = {};
        $scope.pageClass = 'login-form';
        $scope.softDate = true;

        if (typeof document.documentMode === 'undefined') {
            $scope.validBrowser = true;
        } else {
            $scope.validBrowser = false;
        };
        $scope.enableLogin = function () {
            $scope.validBrowser = true;
        }

        // Focus the id number input
        // password input auto fill bug is with Chrome.
        $('#userIdInput').focus();

        //Show Toaster For Card Save Event
        function showToast(divtoast, message, styleclass) {
            var toast = $mdToast.simple()
                .textContent(message)
                .action('OK')
                .actionKey('z')
                .highlightAction(true)
                .toastClass(styleclass)
                .hideDelay(5000)
                .position('bottom left')
                .parent(divtoast);

            $mdToast.show(toast);
        }

       
        //Login Function
        function processLogin() {
            if (!$scope.progress) {
                $scope.progress = true;

                // Submit form
                common.$http({
                    method: 'POST',
                    url: '/login/security/processLogin.cfm',
                    data: $.param($scope.login),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(function (response) {
                    //[IF] Data ERROR response is present, display specific error message
                    if (response.data.data.ERROR !== undefined) {
                        $scope.progress = false;

                        //Show Error Message         
                        var divtoast = angular.element(document.getElementById('logincard'));
                        $scope.showToast(divtoast, response.data.data.ERROR, 'error-toast');
                    } else {
                        //Determine Location to Redirect User
                        var loc = decodeURIComponent(window.location.href);
                        var desiredLoc = loc.substring(loc.indexOf('[[') + 2, loc.indexOf(']]'));
                        
                        // field employees straight to timesheet
                        if(response.data.data.isfield === true){
                            common.navigateToLink('/login/security/generate-employee-token.cfm?redirect=https://fieldtimesheets.psomas.com/auth/intranet.cfm&to=/timesheets/field');
                            return;
                        }
                        
                        //Redirect User
                        if (desiredLoc.substr(0, 1) == '/') {
                            common.navigateToLink(decodeURIComponent(desiredLoc), false);
                        } else {
                            common.navigateToLink('/home');
                        }
                    }
                }, function (error) {
                    $scope.progress = false;

                    //Get Form DOM Element
                    var divtoast = angular.element(document.getElementById('logincard'));

                    //Show Toaster Message
                    var message = "An unknown server error occured. Please try again later.";
                    $scope.showToast(divtoast, message, 'error-toast');
                });
            }
        }
    }

})();

(function(){

    'use strict';

    angular
        .module('app.core',[
            'ngRoute',
            'ngCookies',
            'ngAnimate',
            'ngAria',
            'ngMessages',
            'ngSanitize',
            'ngMaterial',
            'ui.validate',
            'Logger',
            'psomas.theme',
            'psomas.barSimple',
            'Utilities'
        ]);
        
})();


(function(){

    'use strict';

    angular
        .module('app.core')
        .config(['$routeProvider','$locationProvider',function($routeProvider,$locationProvider) {

            $routeProvider
                .when('/', {
                    templateUrl: 'src/app/login/login.html?rev=' + _revision,
                    controller: 'loginCtrl'
                })
                .when('/forgot', {
                    templateUrl: 'src/app/forgot/request.html?rev=' + _revision,
                    controller: 'requestPasswordController'
                })
                .when('/password/reset/:encrypasskey', {
                    templateUrl: 'src/app/forgot/reset.html?rev=' + _revision,
                    controller: 'resetPasswordController'
                })
                .when('/timedout',{
                    templateUrl: 'src/app/timedout/timedout.html?rev=' + _revision,
                    controller: 'timedoutCtrl'
                })
                .otherwise({redirectTo:'/'});


                $locationProvider.html5Mode(true);

        }]);

})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('loginservice',loginservice);

  
    //********************************************************
    //ALERT Service
    //********************************************************
    loginservice.$inject = ['utility'];

    function loginservice(utility) {
        var service = {
            requestPasswordReset: requestPasswordReset,
            getPasswordRequest: getPasswordRequest,
            completePasswordRequest: completePasswordRequest            
        };
        return service;

        //Request Password Reset
        function requestPasswordReset(params){
            return utility.HttpService.sendRequest('/user/password/request/create',params,"POST");
        }

        //Get Password Request
        function getPasswordRequest(params){
            return utility.HttpService.sendRequest('/user/password/request/get',params,"POST");
        }

        //Update Password
        function completePasswordRequest(params){
            return utility.HttpService.sendRequest('/user/password/request/complete',params,"POST");
        } 
    }

})();

(function(){

    'use strict';

    angular.module('app.core')
        .value('config', { appTitle:'Login', version: '2.0'});
        

})();

(function(){

    'use strict';

    angular
        .module('app.core')
        .factory('common', common);

    common.$inject = ['$log','$http','$location','logger','$q','$timeout','$routeParams'];

    function common($log,$http,$location,logger,$q,$timeout,$routeParams) {

        var factory = {
            navigateToLink: navigateToLink,
            routeTo: routeTo,
            $log: $log,
            $http: $http,
            logger: logger,
            $q: $q,
            $timeout: $timeout,
            $routeParams: $routeParams
        };
        return factory;

        // load a new page
        function navigateToLink(link){
            document.location.href = link;
        }

        // change app route
        function routeTo(path){
            $location.path(path);
        }

    }

})();

(function(){

    'use strict';

    angular
        .module('app.timedout',[])
        .controller('timedoutCtrl', timedoutCtrl);

    timedoutCtrl.$inject = ['$scope','common','$timeout'];

    function timedoutCtrl($scope, common, $timeout) {

        common.$log.log('timedoutCtrl has been called.');

        $scope.pageClass = 'forgot-password';
        
        $timeout(function() {
            common.routeTo("/login");
        },10000);

    }

})();


(function(){

    'use strict';

    angular
        .module('app.forgot',[]);

})();


(function(){

    'use strict';

    angular
        .module('app.forgot')
        .controller('resetPasswordController', resetPasswordController);

    resetPasswordController.$inject = ['$scope','common','loginservice','$mdToast'];

    function resetPasswordController($scope,common,loginservice,$mdToast) {
        //Methods
        $scope.init = init;
        $scope.getPasswordChangeRequest = getPasswordChangeRequest;
        $scope.completePasswordRequest = completePasswordRequest;
        $scope.showToast = showToast;
        $scope.checkPasswordMatch = checkPasswordMatch;
        
        //Variables
        $scope.encrypasskey = common.$routeParams.encrypasskey;
        $scope.form = {password1: undefined, password2: undefined, fieldtype: 'password'};
        $scope.changerequest = undefined;
        $scope.progress = true;
        $scope.expired = undefined;
        $scope.title = "Change Password for";
        $scope.updatestatus = 0;

        //Controller Init
        $scope.init();
        function init(){
            $scope.getPasswordChangeRequest();
        }

        //Show Toaster For Card Save Event
        function showToast(divtoast,message,styleclass){
             var toast = $mdToast.simple()
                .textContent(message)
                .action('OK')
                .actionKey('z')
                .highlightAction(true)
                .toastClass(styleclass)
                .hideDelay(0)
                .position('bottom left')
                .parent(divtoast);

            $mdToast.show(toast);
        }

        //Get Password Change Request by Encrypted Pass Key
        function getPasswordChangeRequest(){            
            var params = {encrypasskey:$scope.encrypasskey, applicationid: 1};
            loginservice.getPasswordRequest(params).then(
                function(results){
                    $scope.progress = false;

                    //[IF] Password change request doesn't exist, or its completed or expired, redirect to login [ELSE] Set Change Request Variable
                    if(results.data.length !== 1){
                        common.navigateToLink('/home');
                    }else{
                        if(results.data[0].STATUSID===1){
                            $scope.changerequest = results.data[0];
                            $scope.title = $scope.title + ' ' + $scope.changerequest.USERFULLNAME;
                            $scope.expired = false;
                        }
                        else if(results.data[0].STATUSID===3){
                            $scope.title = "Link Expired";
                            $scope.expired = true;
                        }
                        else{
                            common.navigateToLink('/home');                           
                        }
                    }
                }    
            );
        }

        //Update user password and mark change request as complete
        function completePasswordRequest(){            
            $scope.progress = true;
            $scope.form.fieldtype = 'password';
            var params = {encrypasskey:$scope.encrypasskey, password: $scope.form.password1};            
            loginservice.completePasswordRequest(params).then(
                function(results){
                    $scope.progress = false;
                    if(results.data !== undefined && results.data[0].STATUSID===2){
                        $scope.updatestatus = 1;
                        common.logger.success('Your password has been reset successfully.','','Password Updated');
                        common.routeTo('/login/');
                    }else{                        
                        $scope.updatestatus = 0;

                        //Show Toaster Error Message
                        var divtoast = angular.element(document.getElementById('resetcard'));
                        var message = "There was an issue updating your password. Please try again later";
                        $scope.showToast(divtoast,message,'error-toast');
                    }
                }    
            );
        }

        //Check to see if passwords match
        function checkPasswordMatch(){
            if($scope.form.password1 === $scope.form.password2){
                return true;
            }else{
                return false;
            }
        } 
    }


})();


(function(){

    'use strict';

    angular
        .module('app.forgot')
        .controller('requestPasswordController', requestPasswordController);

    requestPasswordController.$inject = ['$scope','common','loginservice','$mdToast','$window'];

    function requestPasswordController($scope,common,loginservice,$mdToast,$window) {
        //Methods
        $scope.init = init;
        $scope.sendPasswordChangeRequest = sendPasswordChangeRequest;
        $scope.showToast = showToast;
        
        //Variables
        $scope.emailaddress = undefined;
        $scope.progress = false;
        $scope.message = 'Success! Check your email for a link to reset your password. If it doesn’t appear within a few minutes, check your spam folder.';
        $scope.sent = 0;
        $scope.progress = 0;

        //Controller Init
        $scope.init();
        function init(){
        }

        //Show Toaster For Card Save Event
        function showToast(divtoast,message,styleclass){
             var toast = $mdToast.simple()
                .textContent(message)
                .action('OK')
                .actionKey('z')
                .highlightAction(true)
                .toastClass(styleclass)
                .hideDelay(0)
                .position('bottom left')
                .parent(divtoast);

            $mdToast.show(toast);
        }

        //Send user a password change link
        function sendPasswordChangeRequest(){
            $scope.progress = 1;
            var params = {emailaddress: $scope.emailaddress, applicationid:1, ipaddress: _remoteAddress, typeid: 1, sourcemodule: 'Login'};            
            loginservice.requestPasswordReset(params).then(
                function(results){
                    $scope.sent = 1;
                    $scope.progress = 0;
                }    
            );
        }      
    }

})();


(function(){

    'use strict';

    angular
        .module('app', [
            // Core
            'app.core',
            'app.login',
            'app.forgot',
            'app.timedout'
        ])
        .controller('appController', appController);

        appController.$inject = ['$scope', 'common'];

        function appController($scope, common) {

            // make common methods available to view
            $scope.common = common;
            
        }

})();
